<template>

    <el-row v-show="!hidden && !disabled" :gutter="20">
        <el-col :span="24">
            <div class="graph-container">

                <div class="graph-title">
                    {{title}}
                    <div class="graph-title-buttons">
                        <div :title="$l('graphs/preload')" @click="onPreloadClicked" class="graph-title-button" :class="{'graph-title-button-active':isPreloading}" style="font-size:17px">
                            <icon  name="hourglass-half" ></icon>
                        </div>
                        <div :title="$l('graphs/reset')" @click="onResetClicked" v-if="isReset" class="graph-title-button" >
                            <i class="icon-sync"></i>
                        </div>
                        <div :title="$l('graphs/sync')"  @click="onSyncClicked"  class="graph-title-button" v-show="config.graphType != 'spect' && config.graphType != 'statistics'">
                            <img class="weather-sync" v-bind:class="{ 'button-active-bg': sync }" src="../../assets/sync.png">
                        </div>
                        <el-popover
                            ref="export-noise-popover"
                            placement="bottom"

                            trigger="click">
                            <export-graph v-bind:chart="$refs.chart"></export-graph>
                        </el-popover>
                        <div :title="$l('graphs/exportGraph')" v-if="$p('graphsexport')" v-popover:export-noise-popover class="graph-title-button picture-image">
                            <i class="el-icon-picture"></i>
                        </div>
                        <div :title="$l('graphs/hideShow')" @click="onHideGraphClicked" class="graph-title-button">
                            <i v-show="isVisible" class="el-icon-arrow-down"></i>
                            <i v-show="!isVisible" class="el-icon-arrow-right"></i>
                        </div>
                    </div>
                    <div v-if="config.graphType == 'statistics'" class="statistics-top">
                        <div class="download-top-bar">
                            <el-form inline class="inline-form-statistics">
                            <el-form-item class="stat-form-item">
                                <div @click="statDayDownloadClicked">
                                    <el-button size="small" class="stat-form-item-button"><icon class="download-stat-icon" name="file-word-o"></icon></el-button>
                                </div>
                            </el-form-item>
                            </el-form>
                            <div class="stat-form-container">
                                <el-form inline class="inline-form-statistics">
                                    <el-form-item class="stat-form-item">
                                        <el-input v-model="statform.title" size="small" :placeholder="$l('graphs/statTitle')"></el-input>
                                    </el-form-item>
                                    <el-form-item class="stat-form-item">
                                        <el-date-picker :picker-options="{firstDayOfWeek:1}" v-model="statform.from" size="small" type="date" :placeholder="$l('graphs/statFrom')" style="width: 100%;"></el-date-picker>
                                    </el-form-item>
                                    <el-form-item class="stat-form-item">
                                        <el-date-picker :picker-options="{firstDayOfWeek:1}" v-model="statform.to" size="small" type="date" :placeholder="$l('graphs/statTo')" style="width: 100%;"></el-date-picker>
                                    </el-form-item>
                                    <el-form-item class="stat-form-item">
                                        {{selectedStatisticsTemplate}}
                                    </el-form-item>
                                    <el-form-item class="stat-form-item">
                                         <div @click="stateRangeDownloadClicked">
                                            <el-button size="small" class="stat-form-item-button"><icon class="download-stat-icon" name="download"></icon></el-button>
                                        </div>
                                    </el-form-item>
                                </el-form>

                            </div>

                        </div>
                        <div class="top-barier"></div>
                    </div>
                </div>

                <el-row style="position:relative" v-loading="zoomLoading">
                    <div v-if="isVisible && delayedLoading" class="delay-loading-container">
                        <div @click="onDelayLoadingClick" class="delay-loading-text">{{$l('graphs/load')}}</div>
                    </div>
                    <el-col v-bind:class="{'hide-realtime':!realtimeActive || config.graphType == 'spect'}" :lg="4" class="real-time-seperator">
                        <el-collapse-transition>
                            <div v-show="isVisible" class="graph-body real-time-container">
                                <el-row>
                                    <el-col :lg="24" :sm="(i != 0)?8:24" v-for="(value, i) in latestDataRealtime" v-bind:key="value.name">
                                        <div v-if="i == 0" class="real-time-date">
                                            {{new Date(parseInt(value.data)).toISOString().slice(0,10)}} {{new Date(parseInt(value.data)).toISOString().slice(11,19)}}
                                        </div>
                                        <div v-if="i > 0 && value.data != 'null'" class="real-time-data">
                                            <div class="real-time-data">
                                                <span class="real-time-data-title">{{value.name}}: </span>{{value.data}}
                                            </div>
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>
                        </el-collapse-transition>
                    </el-col>
                    <el-col :lg="(!realtimeActive || config.graphType == 'spect')?24:20">
                        <el-collapse-transition>
                            <div v-show="isVisible" class="graph-body">

                                <div v-if="errorMessage" class="graph-error-message">
                                    <div class="error-text">{{$l(errorMessage)}}</div>
                                </div>
                                <div v-if="noData" class="graph-error-message">
                                    <div class="error-text">{{$l(noData)}}</div>
                                </div>
                                <highcharts class="graph" ref="chart" :options="graphOptions"></highcharts>

                                <el-popover
                                    v-if=" config.graphType == 'noise' && getSettingsAddons.markers == '1'"
                                    placement="right"
                                    :value="markersData.visible"
                                    trigger="manual">
                                    <div :title="$l('graphs/markers')" slot="reference" class="markers-button" @click="markersData.visible = !markersData.visible">
                                        <icon  name="thumb-tack" ></icon>
                                    </div>
                                    <markers-popover :data="markersData" v-on:markerClicked="markerClicked"></markers-popover>
                                </el-popover>
                                <el-popover
                                    v-if=" config.graphType == 'noise' && !realtimeActive && getSettingsAddons.markers == '1'"
                                    placement="right"
                                    trigger="click">
                                    <div :title="$l('graphs/dailyNotes')" slot="reference" class="notes-button" >
                                        <icon  name="sticky-note" ></icon>
                                    </div>
                                    <graph-notes v-bind:data="notesData" v-on:saveClick="saveDailyNoteClicked"></graph-notes>
                                </el-popover>
                            </div>
                        </el-collapse-transition>
                    </el-col>
                </el-row>
            </div>
        </el-col>
            <el-col :span="24" v-if="config.graphType == 'noise' && graphMarkers.length > 0">
                <div class="graph-container markers-container">
                    <el-table class="markers-table"
                        :border="false"
                        style="width: 100%"
                        :data="graphMarkers">
                        <el-table-column
                            :label="$l('graphs/markersTable/name')"
                            >
                            <template slot-scope="scope">
                                <div class="marker-color-table" v-bind:style="{backgroundColor: scope.row.color}"></div>
                                {{scope.row.name}}
                            </template>
                        </el-table-column>
                        <el-table-column
                            :label="$l('graphs/markersTable/startTime')"
                            ><template slot-scope="scope">

                                {{new Date(scope.row.from).toLocaleString('de-AT', {timeZone:'UTC'})}}
                            </template>
                        </el-table-column>
                        <el-table-column
                            :label="$l('graphs/markersTable/endTime')"
                            ><template slot-scope="scope">

                                {{new Date(scope.row.to).toLocaleString('de-AT', {timeZone:'UTC'})}}
                            </template>
                        </el-table-column>
                        <el-table-column
                            :label="$l('graphs/markersTable/type')">
                            <template slot-scope="scope">

                                {{scope.row.type?$l('graphs/markersCat/toggle'):$l('graphs/markersCat/single')}}
                            </template>
                        </el-table-column>
                        <el-table-column
                            width="120">
                            <template slot-scope="scope">

                                <el-popover

                                    placement="left"
                                    width="400"
                                    trigger="click">
                                    <el-button slot="reference" type="text" size="mini">{{$l('graphs/markersCat/note')}}</el-button>
                                    <el-input
                                        type="textarea"
                                        :rows="4"
                                        v-model="scope.row.note">
                                    </el-input>
                                    <el-button @click="saveMarkerNoteClicked(scope.row.id)" style="margin-top:10px; width:100%" type="success" size="mini">{{$l('graphs/markersCat/save')}}</el-button>
                                </el-popover>
                                <el-button style="float:right" @click="removeMarker(scope.row.id)" type="danger" icon="delete" size="mini"></el-button>
                            </template>
                            </el-table-column>
                    </el-table>
                    <div class="hourly-notes">
                        <el-popover
                            v-if=" config.graphType == 'noise' && !realtimeActive && getSelectedHour != ''"
                            placement="right"
                            trigger="click">
                            <el-button class="notes-hour-button" slot="reference" type="text" size="mini">{{$l('graphs/markersCat/note')}}</el-button>
                            <graph-notes v-bind:data="notesHourlyData" v-on:saveClick="saveNoteClicked"></graph-notes>
                        </el-popover>
                    </div>
                </div>
            </el-col>
        <play-audio-dialog v-if="savedAudios.length > 0" v-bind:data="playAudioDialog"></play-audio-dialog>
    </el-row>
</template>

<style>
    .graph-container{
        margin-bottom: 25px;
    }
    .graph-container  .el-loading-mask{
        z-index: 0;
    }
    .graph-title{
        border-bottom:1px solid #e9edef ;
        font-size: 16px;
        padding-bottom: 10px;
        margin: 15px;
        font-weight: 600;
    }

    .graph-title-buttons{
        float: right;
    }
    .weather-sync{
        margin-top: -1px;
        background-color:#2c3e50;
    }
    .weather-sync:hover{
        background-color: #1BBC9B;;
    }
    .graph-title-button{
        float: left;
        font-size: 20px;
        margin-right: 15px;
        margin-top: -3px;
    }
    .graph-title-button:hover{
        color:#1BBC9B;
    }
    .graph-title-button.button-active{
        color:#1BBC9B;
    }
    .button-active-bg{
        background-color:#1BBC9B
    }

    .graph-title-button-active{
        color:#1BBC9B

    }

    .graph-body{
        overflow: hidden;
    }
    .real-time-container{
        margin-right: -11px;
        overflow-y: visible;
        height: auto;
        max-height: 250px;
    }
    .real-time-date{
        font-weight: 600;
        text-align: center;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        margin-left:15px;
        margin-right: 15px;
        padding-bottom: 10px;
    }
    .real-time-data{
        text-align: center;
        font-size: 12px;
        margin-top: 10px;
    }
    .real-time-data-title{
        font-weight: 600;
    }
    .real-time-seperator{
        border-right: 1px solid #e9edef ;
        margin-bottom: 15px;
    }
    .hide-realtime{
        display: none;
    }

    .download-word-button{
        position: absolute;
        left: 10px;
        top:50%;
        transform: translateY(-50%);
    }
    .download-word-button:hover{
        color: #1BBC9B;
    }

     .inline-form-statistics{
        float: left;
    }

    .download-stat-icon{
        font-size: 16px;
        font-weight: 600;
    }
    .download-stat-icon:hover{
        color: #1BBC9B;
    }

    .download-top-bar{
        position: relative;
    }

     /*SYNC ICON*/
    .icon-sync{
        box-sizing: border-box;
        display: inline-block;
        vertical-align: middle;
        position: relative;
        font-style: normal;
        color: inherit;
        text-align: left;
        text-indent: -9999px;
        direction: ltr;
        width: 19px;
        height: 19px;
        border-radius: 50%;
        border: 2px solid;
        border-right-color: transparent;
        border-left-color: transparent;
        margin: 0px;
        margin-bottom: 5px;
    }
    .icon-sync:before{
        -webkit-transform: rotate(-45deg);
        -ms-transform: rotate(-45deg);
        transform: rotate(-45deg);
        right: -6px;
        top: 0;
    }
    .icon-sync:after{
        -webkit-transform: rotate(135deg);
        -ms-transform: rotate(135deg);
        transform: rotate(135deg);
        left: -6px;
        bottom: 0;
    }
    .icon-sync:before, .icon-sync:after{
        content: '';
        pointer-events: none;
        position: absolute;
        width: 0;
        height: 0;
        border-width: 5px;
        border-style: solid;
        border-right-color: transparent;
        border-bottom-color: transparent;
        border-left-color: transparent;
    }

    .graph-error-message{
        position: absolute;
        background-color: rgba(255,255,255,0.9);
        top: 0px;
        bottom: 15px;
        left: 0px;
        right: 0px;
        z-index: 5;
    }
    .error-text{
        font-size: 18px;
        position: absolute;
        top:50%;
        left:50%;
        transform: translate(-50%,-50%);
    }

    .rightFloat{
        float: right;
        margin: 0 50px 0 0;
    }

    .delay-loading-container{
            position: absolute;
            top: 0px;
            bottom: 0px;
            right: 0px;
            left: 0px;
            /* width: 100%; */
            /* height: 100%; */
            background-color: rgba(255,255,255,0.9);
            z-index: 10;
    }
    .delay-loading-text{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        padding: 10px;
        border-radius: 4px;
        min-width: 100px;
        text-align: center;
        border: 1px solid #2b3643;
        cursor: pointer;
    }
    .delay-loading-text:hover{
        background-color: rgba(0, 0, 0, 0.05);
    }

    .statistics-top{
        margin-bottom: 5px;
        width: 100%;
        margin-top: 10px;
    }

    .stat-form-item{
        margin-bottom: 0px;
    }
    .stat-form-item-button{
        padding: 4px;
        margin-top: 4px;
        border: none;
    }

    .stat-form-item .el-input__icon+.el-input__inner{
        padding-right: 10px !important;
    }

    .stat-form-container{
        float:none;
        min-height: 35px;
        display: table;
    }
    .barier{
        height: 10px;;
    }

    .notes-button{
        position:absolute;
        bottom: 5px;
        left: 45px;
        background-color:rgb(66, 99, 129);
        color:#ddd;
        height: 30px;
        width:30px;
        box-sizing: border-box;
        text-align: center;
        padding-top: 6px;
        border-radius: 4px;
        cursor: pointer;
    }
    .notes-button:hover{
        background-color:rgb(84, 126, 165);
    }

    .markers-button{
        position:absolute;
        bottom: 5px;
        left: 5px;
        background-color:rgb(66, 99, 129);
        color:#ddd;
        height: 30px;
        width:30px;
        box-sizing: border-box;
        text-align: center;
        padding-top: 6px;
        border-radius: 4px;
        cursor: pointer;
    }
    .markers-button:hover{
        background-color:rgb(84, 126, 165);
    }

    .markers-table{
        border: none;
    }


    .marker-color-table{
        float:left;
        width:15px;
        height:15px;
        border-radius: 50%;
        margin-right:5px;
        margin-top: 4px;
    }

    .markers-container{
      position: relative;
    }

    .hourly-notes{
      position: absolute;
      top: 10px;
      right: 75px;
      z-index: 1;
    }

    .notes-hour-button{
    }


</style>



<script>
import PlayAudioDialog from './PlayAudioFileDialog';
import ExportGraph from './ExportGraph';
import MarkersPopover from './MarkersPopover';
import GraphNotes from './GraphNotes';

import { getDailyData, getHourlyData, setSelectedInterval, getRealTimeData, saveLocalSettings,getRecHour, getRecDay, getVideoDay, getVideoHour } from '@/store/actions'
import { getUrlEncodedMeasurementDayFile, addDays} from '@/common/utils';
import { mapGetters, mapActions } from 'vuex'
import * as api from '@/api'

export default {
    props:['title', 'config', 'data', 'shared'],
    data(){
        return{
            disabled: false,
            hidden:false,
            visible: true,
            chart: null,
            zoomLoading:false,
            realtimeActive: false,
            realtimePreparing: false,
            latestDataRealtime: [],
            test: '',
            savedAudios: [],
            savedVideos: [],
            playAudioDialog:{visible:false, filename: null},
            graphLoadingId: 0,
            noData:'',
            delayedLoading: false,
            delayedLoadingType:'',
            statform:{
                title:'',
                from:'',
                to:''
            },
            activeToggleMarkers: {},
            graphMarkers: [],
            activeMarkerSelect: null,
            markersData:{
                visible: false
            },
            notesData: {
              value: '',
              id: '',
              date: null
            },
            notesHourlyData:{
              value: '',
              id: '',
              date: null
            }
        }
    },
    computed:{
        ...mapGetters([
            'getSidebarVisible',
            'getSelectedDay',
            'getSelectedHour',
            'getSelectedInterval',
            'getRealtimeEnabled',
            'getLocalSettings',
            'getSettingsAddons',
            'getStatus',
            'getSettingsWeather'
        ]),
        errorMessage: function(){
            if(!this.getRealtimeEnabled) return
            if(this.config.graphType == 'weath'){
                if(this.getStatus.weatherError){
                    return 'graphs/errWeath';
                }
            }
            else if(this.config.graphType == 'noise'){
                if(this.getStatus.noiseError){
                    return 'graphs/errNoise';
                }
            }
            else if(this.config.graphType == 'adio'){
                if(this.getStatus.adioError){
                    return 'graphs/errAdio';
                }
            }

        },
        graphOptions: function(){
            this.config.chart.events.selection = this.selection;
            if(this.config.plotOptions.series.events)this.config.plotOptions.series.events.legendItemClick = this.legendItemClick;

            if(this.config.chart.events.click) this.config.chart.events.click = this.graphClicked;
            if(this.config.plotOptions.series.events.click) this.config.plotOptions.series.events.click = this.graphClicked;


            return this.config;
        },
        sync: function(){
            return (this.getLocalSettings.interface)?this.getLocalSettings.interface.syncgraphs:true;
        },
        isReset: function(){
            return (this.getSelectedInterval.source == this.config.graphType && (this.getSelectedInterval.start != undefined || this.getSelectedInterval.end))
        },
        isVisible:function(){
            if(!this.getLocalSettings.interface) return true;
            if(this.config.graphType == 'weath'){
                return (this.getLocalSettings.interface.weather == 1);
            }
            else if(this.config.graphType == 'noise'){
                return (this.getLocalSettings.interface.noise == 1);
            }
            else if(this.config.graphType == 'spect'){
                return (this.getLocalSettings.interface.spectrum == 1);
            }
            else if(this.config.graphType == 'adio'){
                return (this.getLocalSettings.interface.adio == 1);
            }
            else if(this.config.graphType == 'statistics'){
                return (this.getLocalSettings.interface.statistics ==1);
            }
            return true;
        },
        isPreloading: function(){
            if(!this.getLocalSettings.interface) return false;
            switch(this.config.graphType){
                case 'weath':
                    return (this.getLocalSettings.interface.preloadWeather == 1);
                case 'noise':
                    return (this.getLocalSettings.interface.preloadNoise == 1);
                case 'spect':
                    return (this.getLocalSettings.interface.preloadSpectrum == 1);
                case 'adio':
                    return (this.getLocalSettings.interface.preloadAdio == 1);
                case 'statistics':
                    return (this.getLocalSettings.interface.preloadStatistics == 1);
            }
        },
        selectedStatisticsTemplate(){
            if(!this.getLocalSettings.download) return;
            let output = this.getLocalSettings.download.downlStatistic;
            try{
                if(this.getLocalSettings.download.statistics.mapping[output]){
                    return this.getLocalSettings.download.statistics.mapping[output];
                }
            }catch(err){}
            return output;
        }
    },
    components:{
        'export-graph':ExportGraph,
        'play-audio-dialog':PlayAudioDialog,
        'markers-popover': MarkersPopover,
        'graph-notes': GraphNotes
    },
    watch:{
        getSidebarVisible:function(){
            var chartRef = this.$refs.chart;
            if(chartRef)
                chartRef.chart.reflow();
        },

        getSelectedHour: function(newHour){

        },
        getSelectedInterval: function(newInterval){
            if(!this.hidden &&( newInterval.source == this.config.graphType || this.sync || (newInterval.source == 'noise' && this.config.graphType == 'spect'))){
                this.zoomLoading = true;
                if(this.getSelectedHour == ''){
                    var selectedDay = new Date(Date.UTC(
                        this.getSelectedDay.year,
                        this.getSelectedDay.month,
                        this.getSelectedDay.day
                    ));
                    getDailyData(this.$store, this.config.graphType,selectedDay, newInterval.start, newInterval.end)
                        .then(data =>{
                            var currentGraphLoadingId = Date.now();
                            this.graphLoadingId = currentGraphLoadingId;
                            this.clearGraphData(this.$refs.chart,currentGraphLoadingId);
                            this.fillGraphData(this.$refs.chart, data,currentGraphLoadingId);
                            this.data.loading = false;
                            if(this.config.graphType =='noise'){
                                getRecDay(this.$store, selectedDay)
                                    .then(data=>{
                                        this.addAudioSerie(this.$refs.chart, data.data.audio,currentGraphLoadingId);
                                        this.addVideoSerie(this.$refs.chart, data.data.video,currentGraphLoadingId);
                                    })
                                    .catch(()=>{})
                                    .then(()=>{
                                        return this.getMarkersDay({from: selectedDay})
                                    })
                                    .then(data=>{
                                        this.addGraphMarkers(this.$refs.chart, data.data,data.headers, currentGraphLoadingId);


                                    })
                                    .catch(err=>{})
                                    }
                        })
                        .catch(err=>{
                            this.data.loading = false;
                        })
                        .then(()=>{
                            this.zoomLoading = false;
                        })
                }else{
                    var selectedHour = new Date(Date.UTC(
                        this.getSelectedDay.year,
                        this.getSelectedDay.month,
                        this.getSelectedDay.day,
                        this.getSelectedHour
                    ))
                    getHourlyData(this.$store, this.config.graphType, selectedHour, newInterval.start, newInterval.end)
                        .then(data=>{
                            var currentGraphLoadingId = Date.now();
                            this.graphLoadingId = currentGraphLoadingId;
                            this.clearGraphData(this.$refs.chart,currentGraphLoadingId);
                            this.fillGraphData(this.$refs.chart, data, currentGraphLoadingId);
                            this.config.loading = false;
                            if(this.config.graphType =='noise'){
                                getRecHour(this.$store, selectedHour)
                                    .then(data=>{

                                        this.addAudioSerie(this.$refs.chart, data.data.audio,currentGraphLoadingId);
                                        this.addVideoSerie(this.$refs.chart, data.data.video,currentGraphLoadingId);
                                    })
                                    .catch(()=>{})
                                    .then(()=>{
                                        return this.getMarkersHour({from: selectedHour})
                                    })
                                    .then(data=>{
                                        this.addGraphMarkers(this.$refs.chart, data.data, data.headers, currentGraphLoadingId);
                                    })
                                    .catch(err=>{})

                            }
                        })
                        .catch(err=>{
                            this.config.loading = false;
                        })
                        .then(()=>{
                            this.zoomLoading = false;
                        })
                }
            }

        },
        getRealtimeEnabled: function(enabled){
            if(!enabled){
                this.realtimeActive = false;
                this.realtimePreparing = false;
            }
        },
        getSettingsAddons: function(s){
            if(this.config.graphType == 'noise'){
                this.disabled = (s.noise == 0);
            }
            if(this.config.graphType == 'weath'){
                this.disabled = (s.weather == 0);
            }
            if(this.config.graphType == 'adio'){
                this.disabled = (s.adio == 0);
            }
            if(this.config.graphType == 'statistics'){
                this.disabled = (s.statistics == 0);
            }
        }

    },
    methods: {
        ...mapActions([
            'setDownloading',
            'setDownloadingProgress',
            'getMarkersDay',
            'getMarkersHour',
            'setMarker',
            'deleteMarker',
            'saveMarkerNote',
            'getDailyNote'
        ]),
        isNewGraph: function(currentGraphLoadingId){
            return (currentGraphLoadingId != this.graphLoadingId)
        },
        clearGraphData: function(chart, currentGraphLoadingId, resetZoom=true){
            if(this.config.graphType == 'spect' ||this.config.graphType == 'statistics')
                chart.chart.update({chart:{zoomType:''}})
            else
                chart.chart.update({chart:{zoomType:'x'}})
            //if(this.config.graphType == 'spect' || !chart) return;
            while(chart.chart.series.length > 0 ) {
                if(this.isNewGraph(currentGraphLoadingId)) return;
                chart.chart.series[0].remove( false );
            }
            if(resetZoom)
                chart.chart.zoom();

            this.savedAudios = [];
            this.savedVideos = [];
            chart.chart.xAxis[0].removePlotBand('Video');
            chart.chart.xAxis[0].removePlotBand('Audio');
            chart.chart.xAxis[0].removePlotBand('Marker');

            chart.chart.yAxis[0].removePlotLine('thresholdValue');


            this.graphMarkers = [];
            this.notesData= {
              value: '',
              id: '',
              date: null
            }
            this.notesHourlyData= {
              value: '',
              id: '',
              date: null
            }



            setTimeout(()=>{chart.chart.reflow()},1000);
        },
        fillGraphData: function(chart, data, currentGraphLoadingId){
            if(!chart) return
            if(data.data.length == 0){

                this.visible = false;
                //return;
            }
            this.visible = true;
            var localSettings = this.getLocalSettings;
            var verticalExtremeName = 'NO';
            switch(this.config.graphType){
                case 'weath': verticalExtremeName = 'WE'; break;
                case 'spect': verticalExtremeName = 'SP'; break;
                case 'adio': verticalExtremeName = 'ADIO'; break;
            }
            //chart.chart.events.selection = this.selection;
            if(this.config.graphType == 'spect'){
                var color = undefined;

                for(var i = 1; i < data.headers.length; i++){
                    if(this.isNewGraph(currentGraphLoadingId)) return;
                    var visible = (localSettings.graphs && localSettings.graphs[this.config.graphType])? (localSettings.graphs[this.config.graphType][data.headers[i]]) :true;

                    if(data.headers[i].indexOf('-A')>-1){
                        color = this.LightenDarkenColor(color,100);
                    }else{
                        for(var c = 0; c < localSettings.interface.noiseValues.length; c++){
                            if(localSettings.interface.noiseValues[c].indexOf(data.headers[i]) > -1){
                                color = localSettings.interface.colorsnoise[c];
                                break;
                            }
                        }
                    }

                    chart.chart.addSeries({
                        name: data.headers[i],
                        visible: visible,
                        color: color
                    },false);
                }
                for(var i = 1; i < data.headers.length; i++){
                    var seriesData  = [];
                    for(var k = 0; k < data.data.length; k++){
                        if(this.isNewGraph(currentGraphLoadingId)) return;
                        seriesData.push([this.config.frequencies[k],parseFloat(data.data[k][i])]);
                    }
                    chart.chart.series[i-1].setData(seriesData)
                }
                /*var type = this.config.graphType;
                chart.chart.series.forEach(serie=>{
                        var visible = (localSettings.graphs && localSettings.graphs[type])? (localSettings.graphs[type][serie.name]) :true;
                        serie.visible = visible;
                    })
                chart.chart.legend.update()
                var seriesData = [[],[]];
                for(var i = 0; i < data.data.length; i++){
                    seriesData[0].push([
                        this.config.frequencies[i],
                        parseFloat(data.data[i][1])
                    ])
                    seriesData[1].push([
                        this.config.frequencies[i],
                        parseFloat(data.data[i][2])
                    ])
                }
                chart.chart.series[0].setData(seriesData[0]);
                chart.chart.series[1].setData(seriesData[1]);*/
            }
            else if(this.config.graphType == 'statistics'){
                 for(var i = 1; i <4; i++){
                    if(this.isNewGraph(currentGraphLoadingId)) return;
                    var visible = (localSettings.graphs && localSettings.graphs[this.config.graphType])? (localSettings.graphs[this.config.graphType][data.headers[i]]) :true;
                    var color = undefined;
                    /*if(this.config.graphType == 'weath'){
                        var index = Object.keys(localSettings.interface.colorsWeather).indexOf(data.headers[i])
                        color = localSettings.interface.colorsweath[index % localSettings.interface.colorsweath.length];
                    }
                    else if(this.config.graphType == 'noise' || this.config.graphType == 'spect'){
                        for(var c = 0; c < localSettings.interface.noiseValues.length; c++){
                            if(localSettings.interface.noiseValues[c].indexOf(data.headers[i]) > -1){
                                color = localSettings.interface.colorsnoise[c];
                                break;
                            }
                        }
                    }*/

                    chart.chart.addSeries({
                        step: data.headers[i],
                        lineWidth:1,
                        name: data.headers[i],
                        visible: visible,
                        color: color,
                        yAxis: (this.config.graphType == 'adio' && data.headers[i].indexOf('D')>-1)?1:0
                    },false);
                }
                chart.chart.userOptions.plotOptions.series.pointStart = data.data[0][0].substring(0,10);
                for(var i = 1; i <4; i++){
                    var seriesData  = [];
                    for(var k = 0; k < data.data.length; k++){
                        if(this.isNewGraph(currentGraphLoadingId)) return;
                        seriesData.push([data.data[k][0]*1,parseFloat(data.data[k][i])]);
                    }
                    chart.chart.series[i-1].setData(seriesData)
                }
            }
            else{
                for(var i = 1; i < data.headers.length; i++){
                    if(this.isNewGraph(currentGraphLoadingId)) return;
                    var visible = (localSettings.graphs && localSettings.graphs[this.config.graphType])? (localSettings.graphs[this.config.graphType][data.headers[i]]) :true;
                    var color = undefined;
                    if(this.config.graphType == 'weath'){
                        var index = Object.keys(localSettings.interface.colorsWeather).indexOf(data.headers[i])
                        color = localSettings.interface.colorsweath[index % localSettings.interface.colorsweath.length];
                    }
                    else if(this.config.graphType == 'noise' || this.config.graphType == 'spect'){
                        for(var c = 0; c < localSettings.interface.noiseValues.length; c++){
                            if(localSettings.interface.noiseValues[c].indexOf(data.headers[i]) > -1){
                                color = localSettings.interface.colorsnoise[c];
                                break;
                            }
                        }
                    }
                    chart.chart.addSeries({
                        name: data.headers[i],
                        visible: visible,
                        color: color,
                        yAxis: (this.config.graphType == 'adio' && data.headers[i].indexOf('D')>-1)?1:0,
                    },false);
                }
                for(var i = 1; i < data.headers.length; i++){
                    var seriesData  = [];
                    for(var k = 0; k < data.data.length; k++){
                        if(this.isNewGraph(currentGraphLoadingId)) return;
                        seriesData.push([data.data[k][0]*1,parseFloat(data.data[k][i])]);
                    }
                    chart.chart.series[i-1].setData(seriesData)
                }


            }
            if(localSettings.interface['Rang'+verticalExtremeName+'type'] == '0'){
                var extremes = localSettings.interface['Rang'+verticalExtremeName];
                var positions = this.yExtremCalc(extremes[0],extremes[1]);
                chart.chart.yAxis[0].update({
                        tickPositions: positions
                });
                chart.chart.yAxis[0].setExtremes(positions[0], positions[positions.length-1]);
            }

            this.data.loading  = false;
            //chart.chart.redraw();


        },
        audioClicked: function(event, file){
            this.playAudioDialog.visible = true;
            this.playAudioDialog.filename = file;
            //console.log(file);
        },
        addAudioSerie: function(chart, data, currentGraphLoadingId){
            if(data.length > 0){
               // console.log(data);

                var color = 'rgba(255,0,0,0.5)';
                var visible = (this.getLocalSettings && this.getLocalSettings.graphs && this.getLocalSettings.graphs[this.config.graphType])?(this.getLocalSettings.graphs[this.config.graphType]['Audio']) : true;

                this.savedAudios = [];
                if(this.isNewGraph(currentGraphLoadingId)) return;
                data.forEach(item=>{

                    var timestamp = item[0];
                    var file = item[1];
                    var duration = item[2];
                    if(parseInt(duration) < 5) {
                        duration = "5";
                    }
                    var plotband = {
                        from: parseInt(timestamp),
                        to: parseInt(timestamp) + parseInt(duration)*1000,
                        id: 'Audio',
                        color:color,
                        opacity:0.5,
                        zIndex: 10,
                        events:{
                            click: (event) => this.audioClicked(event, file)
                        }
                    };

                    this.savedAudios.push(plotband)
                    if(visible)
                        chart.chart.xAxis[0].addPlotBand(plotband)
                })


                chart.chart.addSeries({
					type: 'line',
                    name: 'Audio',
                    lineWidth:'15px',
					marker:{enabled:false},
					color: color,
					data:[],
					visible:visible ,
                },false);
                chart.chart.redraw();
            }
        },
        addVideoSerie: function(chart, data, currentGraphLoadingId){
            if(data.length > 0){
                //console.log(data);

                var color = 'rgba(255,255,0,0.5)';
                var visible = (this.getLocalSettings && this.getLocalSettings.graphs && this.getLocalSettings.graphs[this.config.graphType])?(this.getLocalSettings.graphs[this.config.graphType]['Video']) : true;
                this.savedVideos = [];
                if(this.isNewGraph(currentGraphLoadingId)) return;
                data.forEach(item=>{
                    var timestamp = item[0];
                    var file = item[1];
                    var duration = item[2];
                    if(parseInt(duration) < 5){
                        duration = "5";
                    }
                    var plotband = {
                        from: parseInt(timestamp),
                        to:parseInt(timestamp) + parseInt(duration)*1000,
                        id: 'Video',
                        color:color,
                        opacity:0.5,
                        zIndex:10,
                        events:{
                            //click
                        }
                    }

                    this.savedVideos.push(plotband);
                    if(visible)
                        chart.chart.xAxis[0].addPlotBand(plotband);
                })

                chart.chart.addSeries({
					type: 'line',
                    name: 'Video',
                    lineWidth:'15px',
					marker:{enabled:false},
					color: color,
					data:[],
					visible:visible ,
                },false);
                chart.chart.redraw();
            }
        },
        addDailyNote: function(chart, data, header, currentGraphLoadingId){
          if(data.length > 0){
                if(this.isNewGraph(currentGraphLoadingId)) return;


                let hID = header.indexOf('ID');// ["ID", "Name", "Color", "Type", "DateTimeStart", "DateTimeStop"]"DateTimeStop"
                let hName = header.indexOf('Name');
                let hColor = header.indexOf('Color');
                let hType = header.indexOf('Type');
                let hDateTimeStart = header.indexOf('DateTimeStart');
                let hDateTimeStop = header.indexOf('DateTimeStop');
                let hNotes = header.indexOf('Notes');



                data.forEach(d=>{
                    //let fromSplit = d[hDateTimeStart].split('-');
                    let fromDate = new Date( parseInt(d[hDateTimeStart]))

                    if(d[hDateTimeStart].indexOf('-') > -1){
                        fromDate = new Date(d[hDateTimeStart]);
                    }


                    //let toSplit = d[hDateTimeStop].split('-');
                    let toDate = new Date( parseInt(d[hDateTimeStop]))
                    if(d[hDateTimeStop].indexOf('-') > -1){
                        toDate = new Date(d[hDateTimeStop]);
                    }

                    let notes = (hNotes>-1)?d[hNotes]:'';


                    let marker={
                        id: d[hID],
                        name: d[hName],
                        from: fromDate.getTime(),
                        to: toDate.getTime(),
                        type: 'Toggle' == d[hType],
                        color: d[hColor],
                        note: notes

                    }

                    if(marker.id.indexOf('Marker_day')>-1){
                      this.notesData.value = marker.note;
                      this.notesData.id = marker.id;
                      this.notesData.date = marker.from;

                    }
                })
            }
        },
        addGraphMarkers: function(chart, data, header, currentGraphLoadingId){
            if(data.length > 0){
                if(this.isNewGraph(currentGraphLoadingId)) return;




                let hID = header.indexOf('ID');// ["ID", "Name", "Color", "Type", "DateTimeStart", "DateTimeStop"]"DateTimeStop"
                let hName = header.indexOf('Name');
                let hColor = header.indexOf('Color');
                let hType = header.indexOf('Type');
                let hDateTimeStart = header.indexOf('DateTimeStart');
                let hDateTimeStop = header.indexOf('DateTimeStop');
                let hNotes = header.indexOf('Notes');



                data.forEach(d=>{
                    //let fromSplit = d[hDateTimeStart].split('-');

                    let fromDate = new Date( parseInt(d[hDateTimeStart]))

                    if(d[hDateTimeStart].indexOf('-') > -1){
                        fromDate = new Date(d[hDateTimeStart]);
                    }


                    //let toSplit = d[hDateTimeStop].split('-');
                    let toDate = new Date( parseInt(d[hDateTimeStop]))
                    if(d[hDateTimeStop].indexOf('-') > -1){
                        toDate = new Date(d[hDateTimeStop]);
                    }


                    let notes = (hNotes>-1)?d[hNotes]:'';


                    let marker={
                        id: d[hID],
                        name: d[hName],
                        from: fromDate.getTime(),
                        to: toDate.getTime(),
                        type: 'Toggle' == d[hType],
                        color: d[hColor],
                        note:notes
                    }
                    if(marker.id.indexOf('Marker_day')>-1 && this.getSelectedHour == ''){
                      this.notesData.value = marker.note;
                      this.notesData.id = marker.id;
                      this.notesData.date = marker.from;

                    } else if (marker.id.indexOf('Marker_hour')>-1 && this.getSelectedHour != ''){
                      if(new Date(marker.from).getUTCHours() == parseInt(this.getSelectedHour)){
                         this.notesHourlyData.value = marker.note;
                          this.notesHourlyData.id = marker.id;
                          this.notesHourlyData.date = marker.from;
                      }
                    }
                    else if(marker.id.indexOf('Marker_day') == -1 && marker.id.indexOf('Marker_hour') == -1) {
                      if (marker.from > chart.chart.xAxis[0].dataMin && marker.to < chart.chart.xAxis[0].dataMax){
                            this.graphMarkers.push(marker);


                            var plotband = {
                                from: marker.from ,
                                to: marker.to,
                                id: 'Marker',
                                name: marker.id,
                                color:marker.color,
                                opacity:0.5,
                                zIndex: 0,
                            };
                            chart.chart.xAxis[0].addPlotBand(plotband)
                        }
                    }



                })
                                                /*0: "11"
            1: "2018-11-12-19-00-30"
            2: "2018-11-12-19-00-35"
            3: "5"
            4: "Toggle"
            5: "Test"
            6: "#4286f4"
            */
            }
        },


        /*Graph events */
        selection: function(event){
            event.preventDefault();
            if (this.activeMarkerSelect ){
                if (this.activeMarkerSelect.marker.type){
                    var start, end;
                    if(event.xAxis){
                        start = new Date(parseInt(event.xAxis[0].min));
                        end = new Date(parseInt(event.xAxis[0].max));

                        let markerId = this.activeMarkerSelect.marker.id;
                        //toggle
                        let timestamp = new Date().getTime();
                        var plotband = {
                            from: start,
                            to: end,
                            id: 'Marker',
                            color:this.activeMarkerSelect.marker.color,
                            opacity:0.5,
                            zIndex: 0,
                        };
                        this.$refs.chart.chart.xAxis[0].addPlotBand(plotband)

                        let marker = {
                            id: markerId+'-'+timestamp,
                            name: this.activeMarkerSelect.marker.name,
                            from: plotband.from,
                            to: plotband.to,
                            type: this.activeMarkerSelect.marker.type,
                            color: this.activeMarkerSelect.marker.color
                        }
                        this.graphMarkers.push(marker)

                        this.setMarker(marker);

                        return;
                    }
                }
            }
            if(this.config.graphType == 'spect' ||this.config.graphType == 'statistics') return;
            var start, end;
            if(event.xAxis){
                start = new Date(parseInt(event.xAxis[0].min));
                end = new Date(parseInt(event.xAxis[0].max));
            }
            setSelectedInterval(this.$store, start,end, this.config.graphType);


        },
        legendItemClick: function(event){
            var name = event.target.name;
            var enabled = !event.target.visible;
            var localSettings = this.getLocalSettings;
            if(!localSettings.graphs) localSettings.graphs = {};
            if(!localSettings.graphs[this.config.graphType]) localSettings.graphs[this.config.graphType] = {};
            localSettings.graphs[this.config.graphType][name] = enabled;
            saveLocalSettings(this.$store, this.$localStorage, localSettings);

            if(name == 'Audio'){
                var chart = this.$refs.chart;
                if(!enabled){
                    chart.chart.xAxis[0].removePlotBand(name);
                }else{
                    this.savedAudios.forEach(item=>{
                        chart.chart.xAxis[0].addPlotBand(item);
                    })
                }
            }else if(name =='Video'){
                var chart = this.$refs.chart;
                if(!enabled){
                    chart.chart.xAxis[0].removePlotBand(name);
                }else{
                    this.savedVideos.forEach(item=>{
                        chart.chart.xAxis[0].addPlotBand(item);
                    })
                }
            }

        },
        graphClicked: function(event){
            if (!this.realtimeActive && this.activeMarkerSelect && !this.activeMarkerSelect.marker.type){

                let value = (event.xAxis && event.xAxis[0])? event.xAxis[0].value : event.point.x;

                let markerId = this.activeMarkerSelect.marker.id;
                //single
                let timestamp = new Date().getTime();
                var plotband = {
                    from: parseInt(value) ,
                    to: parseInt(value) + 2000,
                    id: 'Marker',
                    color:this.activeMarkerSelect.marker.color,
                    opacity:0.5,
                    zIndex: 0,
                };
                this.$refs.chart.chart.xAxis[0].addPlotBand(plotband)
                let marker = {
                    id: markerId+'-'+timestamp,
                    name: this.activeMarkerSelect.marker.name,
                    from: plotband.from,
                    to: plotband.to,
                    type: this.activeMarkerSelect.marker.type,
                    color: this.activeMarkerSelect.marker.color
                }
                this.graphMarkers.push(marker)

                this.setMarker(marker);

            }
        },

        /*REALTIME */
        prepareRealtime: function(currentGraphLoadingId){
            //console.log('Realtime prepare');
            this.realtimePreparing = true;
            this.latestDataRealtime = [];
            getRealTimeData(this.$store, this.config.graphType, this.getLocalSettings.interface.rtvalues)
                .then(data=>{
                    this.fillRealtimeGraph(this.$refs.chart, data, currentGraphLoadingId);
                })
        },

        fillRealtimeGraph: function(chart, data, currentGraphLoadingId){


            this.clearGraphData(chart, currentGraphLoadingId);
            chart.chart.update({chart:{zoomType:''}})
            var localSettings = this.getLocalSettings;
            if(data.headers.length > 0 && data.data.length > 0){
                var verticalExtremeName = 'NO';
                switch(this.config.graphType){
                    case 'weath': verticalExtremeName = 'WE'; break;
                    case 'spect': verticalExtremeName = 'SP'; break;
                    case 'adio': verticalExtremeName = 'ADIO'; break;
                }
                if(this.config.graphType == 'noise'){

                    //set series
                    if(this.isNewGraph(currentGraphLoadingId)) return;
                    this.latestDataRealtime.push({name:'datetime'});
                    for(var i = 1; i < data.headers.length; i++){

                        var visible = (localSettings.graphs && localSettings.graphs[this.config.graphType])? (localSettings.graphs[this.config.graphType][data.headers[i]]) :true;
                        var color = undefined;
                        for(var c = 0; c < localSettings.interface.noiseValues.length; c++){
                            if(localSettings.interface.noiseValues[c].indexOf(data.headers[i]) > -1){
                                color = localSettings.interface.colorsnoise[c];
                                break;
                            }
                        }
                        chart.chart.addSeries({
                            name:data.headers[i],
                            visible: visible,
                            color: color
                        })
                        this.latestDataRealtime.push({name: data.headers[i]});
                    }
                    var k;
                    for(var i = 1; i < data.headers.length; i++){
                        var seriesData  = [];
                        for(k = 0; k < data.data.length; k++){
                            seriesData.push([data.data[k][0]*1,parseFloat(data.data[k][i])]);
                        }
                        chart.chart.series[i-1].setData(seriesData)
                        this.latestDataRealtime[i].data = data.data[k-1][i];
                    }
                    this.latestDataRealtime[0].data = data.data[k-1][0];


                    chart.chart.xAxis[0].setExtremes(chart.chart.xAxis[0].getExtremes().dataMin, chart.chart.xAxis[0].getExtremes().dataMin+parseInt(this.getLocalSettings.interface.rtvalues)*1000,false);

                    if(localSettings.interface.showNoiseTriggerLevel && data.threshold){
                        var plotLines = [];
                        if(data.threshold.value[0] != '-100'){
                            plotLines.push({
                                value: data.threshold.value[0],
                                color: 'green',
                                dashStyle: 'shortdash',
                                width : 2,
                                color: 'green',
                                label:{
                                    text:data.threshold.name,
                                    align:'right',
                                    y:15,
                                    x:-20,
                                }
                            })
                        }
                        if(data.threshold.value[1] != '-100'){
                            plotLines.push({
                                id:'thresholdValue',
                                value: data.threshold.value[1],
                                color: 'green',
                                dashStyle: 'shortdash',
                                width : 2,
                                color: 'green',
                                label:{
                                    text:data.threshold.name,
                                    align:'right',
                                    y:15,
                                    x:-20,
                                }
                            })
                        }

                        plotLines.forEach(line=>{
                            chart.chart.yAxis[0].addPlotLine(line);
                        })
                    }

                    chart.chart.redraw();

                    setTimeout(()=>{chart.chart.reflow()},500);
                }
                else if(this.config.graphType == 'weath'){
                    if(this.isNewGraph(currentGraphLoadingId)) return;
                    this.latestDataRealtime.push({name:'datetime'});
                    for(var i = 1; i < data.headers.length; i++){
                        var visible = (localSettings.graphs && localSettings.graphs[this.config.graphType])? (localSettings.graphs[this.config.graphType][data.headers[i]]) :true;
                        var color = undefined;
                        color = localSettings.interface.colorsWeather[data.headers[i]];
                        chart.chart.addSeries({
                            name:data.headers[i],
                            color:color,
                            visibl: visible
                        })
                        this.latestDataRealtime.push({name: data.headers[i]});
                    }
                    for(var i = 1; i < data.headers.length; i++){
                        var seriesData  = [];
                        for(k = 0; k < data.data.length; k++){
                            seriesData.push([data.data[k][0]*1,parseFloat(data.data[k][i])]);
                        }
                        chart.chart.series[i-1].setData(seriesData)
                        this.latestDataRealtime[i].data = data.data[k-1][i];
                    }
                    this.latestDataRealtime[0].data = data.data[k-1][0];
                    chart.chart.redraw();
                }
                else if(this.config.graphType == 'spect'){
                    this.hidden = false;
                    var color = undefined;
                    for(var i = 1; i < data.headers.length; i++){
                        if(this.isNewGraph(currentGraphLoadingId)) return;

                        var visible = (localSettings.graphs && localSettings.graphs[this.config.graphType])? (localSettings.graphs[this.config.graphType][data.headers[i]]) :true;

                        if(data.headers[i].indexOf('-A')>-1){
                            color = this.LightenDarkenColor(color,100);
                        }else{
                            for(var c = 0; c < localSettings.interface.noiseValues.length; c++){
                                if(localSettings.interface.noiseValues[c].indexOf(data.headers[i]) > -1){
                                    color = localSettings.interface.colorsnoise[c];
                                    break;
                                }
                            }
                        }

                        chart.chart.addSeries({
                            name: data.headers[i],
                            visible: visible,
                            color: color
                        },false);
                    }
                    for(var i = 1; i < data.headers.length; i++){
                        var seriesData  = [];
                        for(var k = 0; k < data.data.length; k++){
                            if(this.isNewGraph(currentGraphLoadingId)) return;
                            seriesData.push([this.config.frequencies[k],parseFloat(data.data[k][i])]);
                        }
                        chart.chart.series[i-1].setData(seriesData)
                    }
                }
                else if(this.config.graphType == 'adio'){
                    this.latestDataRealtime.push({name:'datetime'});
                    for(var i = 1; i < data.headers.length; i++){
                        if(this.isNewGraph(currentGraphLoadingId)) return;
                        var visible = (localSettings.graphs && localSettings.graphs[this.config.graphType])? (localSettings.graphs[this.config.graphType][data.headers[i]]) :true;

                        chart.chart.addSeries({
                            name: data.headers[i],
                            visible: visible,
                            color: color,
                            yAxis: (this.config.graphType == 'adio' && data.headers[i].indexOf('D')>-1)?1:0
                        },false);
                        this.latestDataRealtime.push({name: data.headers[i]});
                    }
                    for(var i = 1; i < data.headers.length; i++){
                        var seriesData  = [];
                        for(var k = 0; k < data.data.length; k++){
                            if(this.isNewGraph(currentGraphLoadingId)) return;
                            seriesData.push([data.data[k][0]*1,parseFloat(data.data[k][i])]);
                        }
                        this.latestDataRealtime[i].data = data.data[k-1][i];
                        chart.chart.series[i-1].setData(seriesData)
                    }
                    this.latestDataRealtime[0].data = data.data[k-1][0];
                }
            }
            if(localSettings.interface['Rang'+verticalExtremeName+'type'] == '0'){
                var extremes = localSettings.interface['Rang'+verticalExtremeName];
                var positions = this.yExtremCalc(extremes[0],extremes[1]);
                chart.chart.yAxis[0].update({
                    tickPositions: positions
                });
                chart.chart.yAxis[0].setExtremes(positions[0], positions[positions.length-1]);

            }
            this.realtimePreparing = false;
            this.realtimeActive = true;



        },

        reloadRealtime: function(currentGraphLoadingId){
            getRealTimeData(this.$store, this.config.graphType, this.getLocalSettings.interface.rtvalues)
                .then(data=>{
                    try{this.reloadGraphData(this.$refs.chart, data, currentGraphLoadingId)}catch(err){
                        console.log(err);
                    };
                });
        },
        reloadGraphData: function(chart, data){
            if(data.length!=0){
                if(this.config.graphType == 'noise'){
                    var rightOffset;
                    for(rightOffset = data.data.length-1; rightOffset >= 0; rightOffset--){
                        if(data.data[rightOffset][0].indexOf(chart.chart.xAxis[0].dataMax) > -1){
                            rightOffset++;
                            break;
                        }
                    }

                   // console.log(data.data.length, rightOffset);
                    var elementsCount = (chart.chart.xAxis[0].getExtremes().dataMax - chart.chart.xAxis[0].getExtremes().dataMin)/1000;
                    var shift = (elementsCount > this.getLocalSettings.interface.rtvalues);

                  //  console.log(shift);
                    var offsetData = data.data.splice(rightOffset);
                    //console.log(data.data.length, offsetData.length);
                    for(var i = 1; i < data.headers.length; i++){

                        for(var k = 0; k < offsetData.length; k++){
                            chart.chart.series[i-1].addPoint({
                                x: offsetData[k][0]*1,
                                y: parseFloat(offsetData[k][i])
                            }, false, shift);
                        }
                        if(offsetData.length>0){
                            this.latestDataRealtime[i].data = offsetData[k-1][i];
                            this.latestDataRealtime[0].data = offsetData[k-1][0];
                            //this.test = offsetData[k-1][0];
                        }
                    }
                    this.latestDataRealtime = JSON.parse(JSON.stringify(this.latestDataRealtime));

                    /*chart.chart.xAxis[0].setExtremes(
                        chart.chart.xAxis[0].getExtremes().dataMin+1000,
                        chart.chart.xAxis[0].getExtremes().dataMin+3600*1000,
                        false
                    )*/

                    Object.keys(this.activeToggleMarkers).forEach(markerId=>{
                        this.activeToggleMarkers[markerId].plotband.to = this.$refs.chart.chart.xAxis[0].dataMax;

                    })
                    chart.chart.xAxis[0].update();
                    chart.chart.xAxis[0].setExtremes(chart.chart.xAxis[0].getExtremes().dataMin+1000,chart.chart.xAxis[0].getExtremes().dataMin+parseInt(this.getLocalSettings.interface.rtvalues)*1000+8000,false);
                    chart.chart.redraw();
                }
                else if(this.config.graphType == 'weath' || this.config.graphType == 'adio'){
                    var rightOffset;
                    for(rightOffset = data.data.length-1; rightOffset >= 0; rightOffset--){
                        if(data.data[rightOffset][0].indexOf(chart.chart.xAxis[0].dataMax) > -1){
                            rightOffset++;
                            break;
                        }
                    }

                    var elementsCount = (chart.chart.xAxis[0].getExtremes().dataMax - chart.chart.xAxis[0].getExtremes().dataMin)/1000;
                    var shift = (elementsCount > this.getLocalSettings.interface.rtvalues);

                    var offsetData = data.data.splice(rightOffset);
                    //console.log(data.data.length, offsetData.length);
                    for(var i = 1; i < data.headers.length; i++){

                        for(var k = 0; k < offsetData.length; k++){
                            chart.chart.series[i-1].addPoint({
                                x: offsetData[k][0]*1,
                                y: parseFloat(offsetData[k][i])
                            }, false, shift);
                        }
                        if(offsetData.length > 0){
                            this.latestDataRealtime[i].data = offsetData[k-1][i];
                            this.latestDataRealtime[0].data = offsetData[k-1][0];
                        }
                    }
                    this.latestDataRealtime = JSON.parse(JSON.stringify(this.latestDataRealtime));
                    chart.chart.xAxis[0].setExtremes(chart.chart.xAxis[0].getExtremes().dataMin+1000,chart.chart.xAxis[0].getExtremes().dataMin+parseInt(this.getLocalSettings.interface.rtvalues)*1000,false);
                    chart.chart.redraw();
                }
                else if(this.config.graphType == 'spect'){
                    this.clearGraphData(chart);
                    var seriesData = [[],[]];
                    for(var i = 0; i < data.data.length; i++){
                        seriesData[0].push([
                            this.config.frequencies[i],
                            parseFloat(data.data[i][1])
                        ])
                        seriesData[1].push([
                            this.config.frequencies[i],
                            parseFloat(data.data[i][2])
                        ])
                    }
                    chart.chart.series[0].setData(seriesData[0]);
                    chart.chart.series[1].setData(seriesData[1]);

                    chart.chart.redraw();
                }

            }
        },

        //EVENTS
        onSyncClicked: function(){
            this.getLocalSettings.interface.syncgraphs = !this.getLocalSettings.interface.syncgraphs;
            //this.getLocalSettings.interface.syncgraphs = this.shared.sync;
            saveLocalSettings(this.$store, this.$localStorage, this.getLocalSettings);
        },

        onPreloadClicked: function(){
            var newValue = 1;
            if(this.isPreloading){
                newValue = 0;
            }
            switch(this.config.graphType){
                case 'weath':
                    this.getLocalSettings.interface.preloadWeather = newValue;
                    break;
                case 'noise':
                    this.getLocalSettings.interface.preloadNoise = newValue;
                    break;
                case 'spect':
                    this.getLocalSettings.interface.preloadSpectrum = newValue;
                    break;
                case 'adio':
                    this.getLocalSettings.interface.preloadAdio = newValue;
                    break;
                case 'statistics':
                    this.getLocalSettings.interface.preloadStatistics = newValue;
                    break;
            }

            saveLocalSettings(this.$store, this.$localStorage, this.getLocalSettings);
        },

        onResetClicked: function(){
            setSelectedInterval(this.$store, undefined,undefined,  this.config.graphType);
        },

        checkIfEnabled: function(){
            if(this.getSettingsAddons && this.config.graphType == 'noise'){
                this.disabled = (this.getSettingsAddons.noise == 0);
            }
            if(this.getSettingsAddons && this.config.graphType == 'weath'){
                this.disabled = (this.getSettingsAddons.weather == 0);
            }
            if(this.getSettingsAddons && this.config.graphType == 'adio'){
                this.disabled = (this.getSettingsAddons.adio == 0);
            }
            if(this.getSettingsAddons && this.config.graphType == 'statistics'){
                this.disabled = (this.getSettingsAddons.statistics == 0);
            }

        },

        onHideGraphClicked: function(){
            if(!this.isVisible)
                setTimeout(()=>this.$refs.chart.chart.reflow(),500);
            if(this.config.graphType == 'weath'){
                var localSettings = this.getLocalSettings;
                localSettings.interface.weather = (localSettings.interface.weather == 1)?0:1;
                saveLocalSettings(this.$store, this.$localStorage, localSettings);
            }
            if(this.config.graphType == 'noise'){
                var localSettings = this.getLocalSettings;
                localSettings.interface.noise = (localSettings.interface.noise == 1)?0:1;
                saveLocalSettings(this.$store, this.$localStorage, localSettings);
            }
            if(this.config.graphType == 'spect'){
                var localSettings = this.getLocalSettings;
                localSettings.interface.spectrum = (localSettings.interface.spectrum == 1)?0:1;
                saveLocalSettings(this.$store, this.$localStorage, localSettings);
            }
            if(this.config.graphType == 'adio'){
                var localSettings = this.getLocalSettings;
                localSettings.interface.adio = (localSettings.interface.adio == 1)?0:1;
                saveLocalSettings(this.$store, this.$localStorage, localSettings);
            }
            if(this.config.graphType == 'statistics'){
                var localSettings = this.getLocalSettings;
                localSettings.interface.statistics = (localSettings.interface.statistics == 1)?0:1;
                saveLocalSettings(this.$store, this.$localStorage, localSettings);
            }
        },
        yExtremCalc: function(graph_min,graph_max) {
            var positions = [];
            var tick = Math.floor(graph_min);
            var divider = 10;
            if (Math.ceil(graph_max - graph_min) < 50 ) {
                divider = 5;
            }
            var increment = Math.ceil((graph_max - graph_min) / divider);
            if (graph_max !== null && graph_min !== null && increment>0) {
                for (tick; tick - increment <= graph_max; tick += increment) {
                    positions.push(tick);
                }
            } else {
                    positions.push(graph_min);
                    positions.push(graph_max);
            }

            return positions;
        },
        LightenDarkenColor(col,amt) {
            var usePound = false;
            if ( col[0] == "#" ) {
                col = col.slice(1);
                usePound = true;
            }

            var num = parseInt(col,16);

            var r = (num >> 16) + amt;

            if ( r > 255 ) r = 255;
            else if  (r < 0) r = 0;

            var b = ((num >> 8) & 0x00FF) + amt;

            if ( b > 255 ) b = 255;
            else if  (b < 0) b = 0;

            var g = (num & 0x0000FF) + amt;

            if ( g > 255 ) g = 255;
            else if  ( g < 0 ) g = 0;

            return (usePound?"#":"") + (g | (b << 8) | (r << 16)).toString(16);
        },

        onDelayLoadingClick(){
            if(this.delayedLoadingType == 'loadDayGraph'){

                this.loadDayGraph();
            }
            else if(this.delayedLoadingType == 'loadHourGraph'){
                this.loadHourGraph();

            }else if(this.delayedLoadingType == 'realtimeReload'){
                try{
                    var currentGraphLoadingId = Date.now();
                    this.graphLoadingId = currentGraphLoadingId;
                    if(this.realtimeActive){
                        this.reloadRealtime(this.graphLoadingId);
                    }else{
                        if(!this.realtimePreparing)
                            this.prepareRealtime(this.graphLoadingId);
                    }
                }catch(err){
                    console.log('Error realtime');
                }
                //this.prepareRealtime(this.graphLoadingId);
            }
            this.delayedLoading = false;
        },
        loadDayGraph(){
            var currentGraphLoadingId = Date.now();
            this.graphLoadingId = currentGraphLoadingId;
            if(!this.config.showOnDay)
            {
                this.hidden = true;
                return;
            }
            var newDay = this.getSelectedDay;
            this.data.loading = true;
            this.hidden = false;
            var selectedDay = new Date(Date.UTC(newDay.year, newDay.month, newDay.day))
            this.noData = '';
            this.clearGraphData(this.$refs.chart, currentGraphLoadingId);
            getDailyData(this.$store, this.config.graphType, selectedDay, undefined, undefined)
                .then(data =>{
                    this.fillGraphData(this.$refs.chart, data, currentGraphLoadingId)
                    //this.data.loading = false;
                })
                .then(()=>{
                    if(this.config.graphType == 'noise'){

                        getRecDay(this.$store, selectedDay)
                            .then(data=>{
                                this.addAudioSerie(this.$refs.chart, data.data.audio, currentGraphLoadingId);
                                this.addVideoSerie(this.$refs.chart, data.data.video, currentGraphLoadingId);

                            })
                            .catch(()=>{})
                            .then(()=>{
                                return this.getMarkersDay({from: selectedDay})
                            })
                            .then(data=>{
                                this.addGraphMarkers(this.$refs.chart, data.data, data.headers, currentGraphLoadingId);
                            })
                            .catch(err=>{})
                    }
                })
                .catch(err=>{
                    if(err.error == 'noData'){
                        this.data.loading = false;
                        this.noData = 'graphs/nodata';
                    }
                })
        },
        loadHourGraph(){
            var currentGraphLoadingId = Date.now();
            this.graphLoadingId = currentGraphLoadingId;
            var newHour = this.getSelectedHour;
            this.data.loading = true;
            this.noData = '';
            if(newHour != ''){
                this.hidden = false;
                var selectedHour = new Date(Date.UTC(this.getSelectedDay.year, this.getSelectedDay.month, this.getSelectedDay.day,newHour));
                this.clearGraphData(this.$refs.chart,currentGraphLoadingId);
                getHourlyData(this.$store, this.config.graphType, selectedHour)
                    .then(data => this.fillGraphData(this.$refs.chart, data, currentGraphLoadingId))
                    .then(()=>{
                        this.data.loading = false;
                        if(this.config.graphType =='noise'){
                            getRecHour(this.$store, selectedHour)
                                .then(data=>{
                                    this.addAudioSerie(this.$refs.chart, data.data.audio, currentGraphLoadingId);
                                    this.addVideoSerie(this.$refs.chart, data.data.video, currentGraphLoadingId);
                                })
                                .catch(()=>{})
                                .then(()=>{
                                    return this.getMarkersHour({from: selectedHour})
                                })
                                .then(data=>{
                                    this.addGraphMarkers(this.$refs.chart, data.data,data.headers, currentGraphLoadingId);
                                })
                                .catch(()=>{})
                                .then(data=>{
                                    return this.getDailyNote(selectedHour)
                                })
                                .then(data=>{
                                  this.addDailyNote(this.$refs.chart, data.data,data.headers, currentGraphLoadingId)
                                })
                                .catch(err=>{})
                        }
                        return;
                    })
                    .catch(err=>{
                        if(err.error == 'noData'){
                            this.data.loading = false;
                            this.noData = 'graphs/nodata';
                        }
                    })
            }
        },
        statDayDownloadClicked(){
            var selectedTime = new Date(Date.UTC(this.getSelectedDay.year, this.getSelectedDay.month, this.getSelectedDay.day));
            var date = getUrlEncodedMeasurementDayFile(selectedTime);
            var url=`/api/reportWord-day&measurement=${date}${'&time='+Date.now()}`
            let title_data = {
                title: this.statform.title,
                templ: this.getLocalSettings.download.downlStatistic,
                lang: this.getLocalSettings.interface.language
            }
            this.setDownloading({enabled: true, progress: 0, preparing:true})
                api.getFileAction(url,'POST',title_data, (progress)=>{
                    let percentage = 100;
                    if (progress.total != 0) {
                        let percentage = Math.round((progress.loaded/progress.total)*100);
                    }
                    this.setDownloadingProgress(percentage);
                })
                .then(()=>{
                    this.setDownloading({enabled: false, progress: 0})
                })
                .catch(()=>{
                    this.setDownloading({enabled: false, progress: 0})

                })

           // window.location.href = url;
        },
        stateRangeDownloadClicked(){
            var fromDate = getUrlEncodedMeasurementDayFile(addDays(this.statform.from,1));
            var toDate = getUrlEncodedMeasurementDayFile(addDays(this.statform.to,1));
            if(!fromDate || !toDate) return;

            var url = `/api/reportWord-range&fromDate=${fromDate}&toDate=${toDate}${'&time='+Date.now()}`;
            let title_data = {
                title: this.statform.title,
                templ: this.getLocalSettings.download.downlStatistic,
                lang: this.getLocalSettings.interface.language
            }
           this.setDownloading({enabled: true, progress: 0, preparing:true})
                api.getFileAction(url,'POST',title_data, (progress)=>{
                    let percentage = 100;
                    if (progress.total != 0) {
                        let percentage = Math.round((progress.loaded/progress.total)*100);
                    }
                    this.setDownloadingProgress(percentage);
                })
                .then(()=>{
                    this.setDownloading({enabled: false, progress: 0})
                })
                .catch(()=>{
                    this.setDownloading({enabled: false, progress: 0})

                })
           // window.location.href = url;
        },

        //Markers and stuff
        markerClicked(markerId, callback){
            let marker = this.getLocalSettings.markers.find(a=> a.id == markerId);
            if(!this.realtimeActive){
                this.activeMarkerSelect={
                    marker,
                    callback
                }
                callback(true, false);
            }else {
                let timestamp = new Date().getTime();
                if (!marker.type){//single
                    var plotband = {
                        from: this.$refs.chart.chart.xAxis[0].dataMax ,
                        to: this.$refs.chart.chart.xAxis[0].dataMax + 2000,
                        id: 'Marker-'+markerId+'-'+timestamp,
                        color:marker.color,
                        opacity:0.5,
                        zIndex: 0,
                    };
                    this.$refs.chart.chart.xAxis[0].addPlotBand(plotband)
                    let markerD = {
                        id: markerId+'-'+timestamp,
                        name: marker.name,
                        from: plotband.from,
                        to: plotband.to,
                        type: marker.type,
                        color: marker.color
                    }
                    this.graphMarkers.push(markerD);
                      this.setMarker(markerD);

                } else {
                    let markerInstance = this.activeToggleMarkers[markerId];
                    if (markerInstance){
                        let plotband = this.activeToggleMarkers[markerId].plotband;
                        let markerD = {
                            id: markerId+'-'+timestamp,
                            name: marker.name,
                            from: plotband.from,
                            to: plotband.to,
                            type: marker.type,
                            color: marker.color
                        }
                        this.graphMarkers.push(markerD)
                        this.setMarker(markerD);
                        delete this.activeToggleMarkers[markerId];
                        callback(false, true);


                    } else {
                        this.activeToggleMarkers[markerId]={
                            plotband:{
                                from: this.$refs.chart.chart.xAxis[0].dataMax ,
                                to: this.$refs.chart.chart.xAxis[0].dataMax + 2000,
                                id: 'Marker-'+markerId,
                                color:marker.color,
                                opacity: 0.1,
                                zIndex: 0,
                            }
                        }



                        this.$refs.chart.chart.xAxis[0].addPlotBand( this.activeToggleMarkers[markerId].plotband)
                        callback(true, true);
                    }
                }
            }
        },
        removeMarker(markerId){
            let marker = this.graphMarkers.find(a=>a.id==markerId);
            let markerIndex = this.graphMarkers.indexOf(marker);
            this.graphMarkers.splice(markerIndex, 1);

            this.deleteMarker(marker);

            this.$refs.chart.chart.xAxis[0].plotLinesAndBands.forEach(pb=>{
                if (pb.options.name == markerId) {
                    pb.destroy();
                }
            })


        },
        saveMarkerNoteClicked(markerId){
            let marker = this.graphMarkers.find(a=>a.id==markerId);

            this.saveMarkerNote({id:marker.id, note:marker.note, date: marker.from});
        },
        saveNoteClicked(){
            if(this.notesHourlyData.id != ''){
              if (this.getSelectedHour != ''){
              //Hour
                this.saveMarkerNote({id:this.notesHourlyData.id, note:this.notesHourlyData.value, date: this.notesHourlyData.date});
              }
            } else {
              if (this.getSelectedHour != ''){
              //Hour
                var newDay = this.getSelectedDay;
                 var newHour = this.getSelectedHour;
                var selectedDay = new Date(Date.UTC(newDay.year, newDay.month, newDay.day, newHour))




                let marker = {
                      id:'Marker_hour-'+selectedDay.getTime(),
                      name: 'Marker_hour',
                      from: selectedDay.getTime(),
                      to: selectedDay.getTime(),
                      type: 'Hour-Note',
                      color: '#ffffff',
                      notes: this.notesHourlyData.value
                  }

                this.setMarker(marker);
              }
            }



        },

        saveDailyNoteClicked(){
           if(this.notesData.id != '')
              this.saveMarkerNote({id:this.notesData.id, note:this.notesData.value, date: this.notesData.date});
            else {
               var newDay = this.getSelectedDay;
                var selectedDay = new Date(Date.UTC(newDay.year, newDay.month, newDay.day, 1))

                let end = new Date(selectedDay);
                end.setHours(23,59, 59);

                let marker = {
                      id:'Marker_day-'+selectedDay.getTime(),
                      name: 'Marker_day',
                      from: selectedDay.getTime(),
                      to: end.getTime(),
                      type: 'Day-Note',
                      color: '#ffffff',
                      notes: this.notesData.value
                  }

                this.setMarker(marker);
            }
        }
    },
    mounted: function(){
        this.checkIfEnabled();

        this.$on('realtimeReload', function(data) {
            this.hidden = false;
            if(!this.realtimeActive && !this.realtimePreparing){
                if(this.isPreloading){
                    this.delayedLoading = true;
                    this.delayedLoadingType = 'realtimeReload'
                    return;
                }else{
                    this.delayedLoading = false;
                }
            }

            this.noData = '';
            var currentGraphLoadingId = Date.now();
            if (!this.realtimeActive && this.realtimePreparing){

            } else {
                this.graphLoadingId = currentGraphLoadingId;
            }

            if (this.config.graphType == 'noise'){

                //console.log('realtimeactive', this.realtimeActive)
            //console.log('realtimepreparing', this.realtimePreparing)
            }

            try{
                if(this.realtimeActive){
                    this.reloadRealtime(currentGraphLoadingId);
                }else{
                    if(!this.realtimePreparing)
                        this.prepareRealtime(currentGraphLoadingId);
                }
            }catch(err){
                console.log('Error');
            }

        });

        this.$on('loadDayGraph', function(data){
            if(!this.config.showOnDay)
            {
                this.hidden = true;
                return;
            }
            if(this.isPreloading){
                this.delayedLoading = true;
                this.delayedLoadingType = 'loadDayGraph'
                return;
            }else{
                this.delayedLoading = false;
            }
            this.loadDayGraph();
        });

        this.$on('loadHourGraph', function(data){
            this.hidden = false;
            if(this.isPreloading){
                this.delayedLoading = true;
                this.delayedLoadingType = 'loadHourGraph'
                return;
            }else{
                this.delayedLoading = false;
            }
            this.loadHourGraph();

        });

    }

}
</script>




// WEBPACK FOOTER //
// Graph.vue?b9db8312